import React, { useState,useRef,useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { FullPage, Slide } from 'react-full-page';
import Slider from "react-slick";
import "../node_modules/slick-carousel/slick/slick.css"; 
import "../node_modules/slick-carousel/slick/slick-theme.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import 'animate.css';
import { Button,Modal } from 'react-bootstrap';
import Fbxloder from './component/Fbxloader'
import useSound from 'use-sound';
import boopSfx from './pop_sound.mp3';
import {reactLocalStorage} from 'reactjs-localstorage';
import axios from "axios";
import {Helmet} from "react-helmet";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
let myInterval;
function Popt() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const [clipActive,setClipActive] = useState(1)
  const [showmenu,setShowmenu] = useState(false)
  const [scoreExpland,setScoreExpland] = useState(false)
  const [activeSlide,setActiveSlide] = useState(0)
  const [shareImage,setShareImage] =  useState("../617aab24957f0.png")
  const [shareLink,setShareLink] =  useState("")
  const mainVdo = useRef(null);
  const vidRef1 = useRef(null);
  const vidRef2 = useRef(null);
  const [modalShow, setModalShow] =  useState(false)
  const [popTire,setPopTire] = useState(false)
  const [score,setScore] = useState(0)
  const [myscore,setMyScore] = useState(0)
  const [users,setUsers] = useState({})
  const [mydata,setMydata] = useState({})
  const [play] = useSound(boopSfx);
  const profile = reactLocalStorage.getObject('profile')
  const urlUsers = 'https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/users/format/json';
  const me = 'https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/me';
  let audio = new Audio("/christmas.mp3")
  const [hours,setHours] = useState(0);
  const [minutes,setMinutes]  = useState(0);
  const [seconds,setSeconds]   = useState(0);
  const [milliseconds,setMilliseconds]  = useState(0);
  const [clicker,setClicker] = useState(false)
  const [startTimer,setStartTimer] = useState(false)
  const [loader,setLoader] = useState(false)
  const toggleScore =()=>{
    
    setScoreExpland(!scoreExpland)
  }
  const toggleShare =()=>{
    setModalShow(!modalShow)
  }
  const togglePopDown =()=>{
    setPopTire(!popTire)
    play()
    setClicker(false)
    if(!startTimer){
      setStartTimer(true)
      Timer()
    }else{
      if(myscore>=1){
        if(!loader){
          setLoader(true)
          SubmitScore()
        }
        
        clearInterval(myInterval);
      }
    }
     
    
  }
  function SubmitScore(){
    let min = (hours*60* 1000)+(seconds * 1000)+milliseconds;
    let bodyFormData = new FormData();
    bodyFormData.append('fb_id',profile.id);
    bodyFormData.append('score', min);
    axios({
      method: "post",
      url: "https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/poptire",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        //setMydata(response.data.me);
        shareFacebook()
        axios.get(urlUsers).then(res => {
          setUsers(res.data)
          console.log(res.data);
        })
        console.log(response.data);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  }    
  function Timer(){
    let num = 0
    var startTime = new Date(); 
      myInterval = setInterval(() => {
       

        var timeElapsed = new Date().getTime() - startTime.getTime();    // calculate the time elapsed in milliseconds    
        setHours(parseInt(timeElapsed / 1000 / 60 / 60));
        
        // calculate minutes
      let min = parseInt(timeElapsed / 1000 / 60)
        if (min > 60) min %= 60;
        setMinutes(min);
        // calculate seconds
      let sec = parseInt(timeElapsed / 1000)
        if (sec > 60) sec %= 60;
        setSeconds(sec);
          num=num+0.01;
        // calculate milliseconds 
      let ml = timeElapsed
        if (ml > 1000) ml %= 1000;
        setMilliseconds(ml);
       
    }, 25)
    return ()=> {
      clearInterval(myInterval);
    };
  }
  const togglePopUp =()=>{

    setPopTire(!popTire)
    setMyScore(myscore + 0.01)
    setClicker(true)
   
    
  }
  const hendleClip =(n)=>{
    setClipActive(n)
    if(n===1){
      vidRef1.current.play();
      vidRef2.current.pause();
      vidRef2.current.currentTime=0;

    }else{
      vidRef2.current.play();
      vidRef1.current.pause();
      vidRef1.current.currentTime=0;
    }
  }
  const toggleCarousel =()=>{
    if(clipActive===1){
      setClipActive(2)
      vidRef2.current.play();
      vidRef1.current.pause();
      vidRef1.current.currentTime=0;
    }else{
      setClipActive(1)
      vidRef1.current.play();
      vidRef2.current.pause();
      vidRef2.current.currentTime=0;
    }
  }
  const hendleChange=(e)=>{
    if(e.to===1){
      mainVdo.current.play();
    }else{
      mainVdo.current.pause();
      mainVdo.current.currentTime=0;
    }
    setActiveSlide(e.to)
  }
  const numCompoment =(num)=>{
    if(num===0){
      return (<img src="../gold.png" />)
    }else if(num===1){
      return (<img src="../silver.png" />)
    }else if(num===2){
      return (<img src="../bronze.png" />)
    }else{
      return (<span>{num+1}</span>)
    }
  }
  const playAgain=()=>{
    window.location.reload()
  }
  const shareFacebook=()=>{
   // setModalShow(!modalShow)
    let bodyFormData = new FormData();
    bodyFormData.append('fb_id', profile.id);
    axios({
      method: "post",
      url: "https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/share",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setShareImage(response.data.imgurl);
        let shareurl = "https://www.goodyear.co.th/assurance-maxguard-suv/services/View/id/"+response.data.imgid;
        let link = "https://www.facebook.com/dialog/feed?app_id=921615008736175&display=popup&link="+shareurl+"&redirect_uri=https://www.goodyear.co.th/assurance-maxguard-suv/pumptire";
        
        setShareLink(link)
        setModalShow(!modalShow)
        console.log(response.data);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  }
  function ShareModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="shareModal"
        backdrop="static"
      >
        <Modal.Header>
            <img src="../Close-button.png" onClick={()=>toggleShare()}/>
        </Modal.Header>
        <Modal.Body>
        <div className="shareblock"> 
              <img src={props.imageurl} className="shareimage"/>
              <a  href={props.sharelink} className="shareonfb"><img src="../fb.png"/> SHARE ON FACEBOOK</a>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

 function prependZero(time, length) {
      time = new String(time);    // stringify time
      return new Array(Math.max(length - time.length + 1, 0)).join("0") + time;
  }
  function convertMsToMinutesSeconds(mil) {
    
    const min = Math.floor(mil / 60000);
    const sec = Math.round((mil % 60000) / 1000);
    const ms = mil % 1000; 
    return sec === 60
      ? `${prependZero(min,2) + 1}:00:${ms}`
      : `${prependZero(min,2) }:${prependZero(sec,2)}:${ms}`;
  }
  useEffect(() => {
   
    
    axios.get(urlUsers).then(res => {
      setUsers(res.data)
      console.log(res.data);
    })

    let bodyFormData = new FormData();
    bodyFormData.append('fb_id', profile.id);
    axios({
      method: "post",
      url: me,
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setMydata(response.data);
        //setScore(response.data.score)
        console.log(response.data);
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  }, [])
  return (
    <div className="poptire container-fuild">
      <Helmet>
        <title>PUMPTIRE - GOOD YEAR ASSURANCE MAXGUARD SUV</title>
        <meta name="ogtitle" property="og:title" content="GOOD YEAR ASSURANCE MAXGUARD SUV" />
        <meta property="og:type" ontent="website"/>
        <meta property="og:image" content="%PUBLIC_URL%/images/facebook-share.jpg"/>
        <meta property="og:description" content="ใหม่ GOOD YEAR ASSURANCE MAXGUARD SUV 2-IN-1 PROTECTION เบรกกระชับ รับแรงกระแทก" />
      </Helmet>
      <video  autoPlay loop muted playsInline className="bg-video">
        <source src={`${(isMobile)?"../video/mobile_bg.mp4":"../video/bg.mp4"}`} type="video/mp4"/>
      </video>
      {
      (isMobile)?
      <header className={"bg-transparent game-header"}>
        <div className="row">
          <div className="col-9 menu">
            <div className="profile">
            <div className="pic"><img src={reactLocalStorage.get("popimg")}/></div>
              <div className="name">{profile.name}</div>
            </div>
          </div>
          <div className="col-3 external">
            <a  onClick={()=>shareFacebook()}><img src="../share.png" className="share-icon"/></a>
          </div>
        </div>
      </header>
      :
      <header className={"bg-transparent game-header"}>
        <div className="row">
          <div className="col-4 menu">
            <div className="profile">
              <div className="pic"><img src={reactLocalStorage.get("popimg")}/></div>
              <div className="name">{profile.name}</div>
            </div>
          </div>
          <div className="col-4 text-center">
          <img src="../Game-logo.png" />
          <div className='time'>TIME : <div> {prependZero(minutes,2)}</div>.<div> {prependZero(seconds,2)}</div>.<div> {prependZero(milliseconds,2)}</div> </div>
          </div>
          <div className="col-4 external">
            <div><a  onClick={()=>shareFacebook()}><img src="../share.png"/></a></div>
            <div className='reloadImg'><a  onClick={()=>playAgain()}><img src="../refresh.png"/></a></div>
          </div>
        </div>
      </header>
      }
      <div className="container game-container">
      {
        (isMobile)?
        <>
        <div className="poptirelogo"> <img src="../Game-logo.png" /></div>
        <div className='time m-time'>TIME : <div> {prependZero(minutes,2)}</div>.<div> {prependZero(seconds,2)}</div>.<div> {prependZero(milliseconds,2)}</div> </div>
        </>
        :
        <></>
        // <div className="myScore">{mydata?.score}</div>
      } 
      {
        (isMobile)? 
        <>
        <img src={"../pop.png"} className={`m wheel-game ${(clicker)?"scaleToggle":""}`}  />
        <img src={"../poptire.png"} className={`m wheel-game ${(clicker)?"scaleToggle":""}`} onTouchStart={()=>togglePopDown()} onTouchEnd={()=>togglePopUp()} style={{opacity:myscore}}/>
        </>
            :
            <>
             <img src={"../pop.png"} className={`wheel-game ${(clicker)?"scaleToggle":""}`}  />
             <img src={"../poptire.png"} className={`wheel-game ${(clicker)?"scaleToggle":""}`}  onMouseDown={()=>togglePopDown()} onMouseUp={()=>togglePopUp()} style={{opacity:myscore}}/>
            </>
           
      }
      </div>
      <div className={`score-block ${(scoreExpland)? "score-block-active":"score-block-hide"}`}>
          <div className="score-head">
            <table className={"w-100"}>
            <tbody>
                <tr>
                    <td className="Seq"><img src="../trophy.png" /></td>
                    <td className={`seq-name ${(scoreExpland)? "text-center":""}`}>{(!scoreExpland) ? "#1 "+ users[0]?.name:"SCOREBOARD"}</td>
                    <td className={"text-end Seq-arrow"}><button className={`score-toggle ${(scoreExpland)? "score-arrow-rotate":""}`} onClick={()=>toggleScore()}>{(!scoreExpland) ? "Score":""}</button></td>
                </tr>
                </tbody>
            </table>
          </div>
          <div className="score-body">
            <table className={"w-100 score-board"}>
            <tbody>
                {
                  (users.length>0)?
                  users.map((item,index)=>(
                
                <tr key={index}>
                    <td className="Seq">{numCompoment(index)}</td>
                    <td className={`seq-name ${(index<3)? "yellow":""}`}>{item.name}</td>
                    <td className={`text-end seq-score ${(index<3)? "yellow":""}`}>{convertMsToMinutesSeconds(item.score)}</td>
                </tr>
                  ))
                  :
                  <></>
      }
                {/* <tr>
                    <td className="Seq"><img src="../silver.png" /></td>
                    <td className={`seq-name`}>Veerachat Saevang</td>
                    <td className={"text-end seq-score"}>20000000</td>
                </tr>
                <tr>
                    <td className="Seq"><img src="../bronze.png" /></td>
                    <td className={`seq-name`}>Veerachat Saevang</td>
                    <td className={"text-end seq-score"}>20000000</td>
                </tr>
                <tr>
                    <td className="Seq"><span>4</span></td>
                    <td className={`seq-name`}>Veerachat Saevang</td>
                    <td className={"text-end seq-score"}>20000000</td>
                </tr> */}
                </tbody>
            </table>
          </div>
      </div> 
    <ShareModal show={modalShow} imageurl={shareImage} sharelink={shareLink}  onHide={() => setModalShow(false)}/>
    </div>
  );
}
export default class Poptire extends React.Component{
    render(){
      return(
        <Popt/>
      )
    }
  }
  
